interface User {
  token: string;
  role: number;
}

export function authHeader(): { Authorization?: string } {
  // return authorization header with jwt token
  const userStr = localStorage.getItem('user');
  if (!userStr) return {};
  
  try {
    const user: User = JSON.parse(userStr);
    if (user && user.token) {
      return { Authorization: 'Bearer ' + user.token };
    } else {
      return {};
    }
  } catch (error) {
    console.error('Error parsing user data:', error);
    return {};
  }
}
